
import Vue from "vue";
import AppProductGroupSelectAutcomplete from "@/components/product-group/ProductGroupSelectAutocomplete.vue";
import { Product } from "@/models/base";
import { DossierConfigService, ProductService } from "@/services";

export default Vue.extend({
	data(){
		return {
			simpleMainGroup: "",
			simpleSubGroup: "",
			groupId: 0,
			isRunning: false
		};
	},
	props: {
		selectedItems: {
			type: Array as ()=>Product[],
			required: true
		}
	},
	computed: {
		useSimpleGroups():boolean {
			return DossierConfigService.getGeneralConfig().UseSimpleGroups;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (this.isRunning) return;
			this.isRunning = true;
			try{
				let productIds = this.selectedItems.map(p=>p.ID);
				let message = this.$ctc("are-you-sure-you-want-to-set-the-group-of-count-products", productIds.length, {count: productIds.length}).toString();
				let confirm = await this.$confirmBuilder().setMessage(message).setWarningTitle().show();
				if (!confirm) return;
				if (!this.useSimpleGroups) {
					await ProductService.setGroup(this.groupId, productIds);
				}else{
					await ProductService.setSimpleGroups(this.simpleMainGroup, this.simpleSubGroup, productIds);
				}
				this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
				this.$emit("refresh");
				this.close();
			}catch(err){

			}finally{
				this.isRunning = false;
			}
		}
	},
	components: {
		AppProductGroupSelectAutcomplete
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
